import { laptopMediumMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';

export const MoreDevelopmentsGroup = styled.div`
  background-color: #fcdbe2;
  border-radius: 5px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 35px 0;

  @media (${laptopMediumMax}) {
    flex-direction: column;
    padding: 15px;
  }
`;

export const MoreDevelopmentsContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  h4 {
    color: ${(props) => props.theme.textDark};
    font-size: 20px;
  }

  @media (${laptopMediumMax}) {
    margin-bottom: 30px;
    flex-direction: column;
    align-items: center;

    h4 {
      text-align: center;
    }
  }
`;

export const MoreDevelopmentsText = styled.div`
  display: flex;
  align-items: center;

  img {
    margin-right: 12px;
    width: 30px;
  }

  p {
    color: ${(props) => props.theme.textLight};
    font-size: 16px;
  }

  b {
    color: ${(props) => props.theme.textDark};
  }

  @media (${laptopMediumMax}) {
    img {
      margin-right: 8px;
      width: 22px;
    }

    margin-top: 8px;
  }
`;
